import React, { Suspense, lazy } from "react"
import { HashRouter as Router, Route, Switch } from "react-router-dom"
import { Spin, ConfigProvider } from "antd"
import zhCN from "antd/es/locale/zh_CN"
import "./App.scss"
const Home = lazy(() => import("./routes/Home"))
const VsArea = lazy(() => import("./routes/vsArea/VsArea"))
const NanHui = lazy(() => import("./routes/NanHui"))

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <Router>
        <Suspense fallback={<Spin />}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/vs-area" component={VsArea} />
            <Route exact path="/nanhui" component={NanHui} />
          </Switch>
        </Suspense>
      </Router>
    </ConfigProvider>
  )
}

export default App
